import { useState, useEffect, useCallback } from 'react'
import { ReactComponent as RefreshIcon } from './icons/refresh.svg'
import Button from '../Forms/Button'
import use3DViewerEvent from '../../hooks/use3DViewerEvent'

const debugInactivityTimeSec = localStorage.getItem('debugInactivityTimeSec')

export default function InactivityPopup() {
  const [showPopup, setShowPopup] = useState(false)
  const [resetTimer, setResetTimer] = useState(false)

  const INACTIVITY_TIME = debugInactivityTimeSec ? Number(debugInactivityTimeSec * 1000) : 6 * 60 * 60 * 1000 // 6 hours in ms

  const clearResetTimer = useCallback(() => {
    clearTimeout(resetTimer)
    setResetTimer(
      setTimeout(() => {
        setShowPopup(true)
      }, INACTIVITY_TIME),
    )
  }, [resetTimer, INACTIVITY_TIME])

  useEffect(() => {
    const events = ['mousedown', 'keydown', 'touchstart']

    events.forEach((event) => {
      document.addEventListener(event, clearResetTimer)
    })

    return () => {
      clearTimeout(resetTimer)
      events.forEach((event) => {
        document.removeEventListener(event, clearResetTimer)
      })
    }
  }, [resetTimer, INACTIVITY_TIME, clearResetTimer])

  useEffect(() => {
    if (!resetTimer) {
      setResetTimer(
        setTimeout(() => {
          setShowPopup(true)
        }, INACTIVITY_TIME),
      )
    }
  }, [resetTimer, INACTIVITY_TIME])

  use3DViewerEvent('user-interaction', ({ event }) => {
    clearResetTimer()
  })

  return (
    <>
      {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 flex items-center justify-center z-[9999]">
          <div className="bg-white p-[32px] rounded-[8px] flex flex-col items-center justify-center text-center max-w-[calc(100%-40px)] lg:w-[400px]">
            <RefreshIcon />
            <div className="text-[18px] mt-[16px] font-medium inline-block">Page Refresh Required</div>
            <div className="text-[16px] font-normal mt-[8px] lg:max-w-[80%]">
              Please refresh the page for a better viewing experience.
            </div>
            <Button
              className="mt-[24px] bg-black w-[134px] lg:w-auto"
              onClick={() => {
                window.location.reload()
              }}
            >
              Refresh now
            </Button>
          </div>
        </div>
      )}
    </>
  )
}
